import { render, staticRenderFns } from "./agreementyyjd.vue?vue&type=template&id=85a957a0&scoped=true"
import script from "./agreementyyjd.vue?vue&type=script&lang=js"
export * from "./agreementyyjd.vue?vue&type=script&lang=js"
import style0 from "./agreementyyjd.vue?vue&type=style&index=0&id=85a957a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a957a0",
  null
  
)

export default component.exports